import React, { useState } from 'react';
import { Container } from './styles';

import { Unit } from '../../../../../../components/ServiceItem';
import format from 'date-fns/format';
import { ptBR } from 'date-fns/locale';
import { UnitCard } from './UnitCard';
import { getUnitIdAndLocalId } from '../../../../../../utils/location';

interface UnitSelectorProps {
  onLocationSelected: (location: Unit) => void;
  selectedUnit: Unit | undefined;

  scheduleUnits: Unit[];
  unitDates: Record<string, string[]>;
}

export const UnitSelector: React.FC<UnitSelectorProps> = ({
  onLocationSelected,
  selectedUnit,
  unitDates,
  scheduleUnits
}) => {
  const getclosestDateAvailable = (unitId: string) => {
    const datesAvailable = unitDates[unitId];
    if (datesAvailable && datesAvailable.length > 0) {
      return format(new Date(datesAvailable[0] + 'T00:00:00'), 'dd/MM/yyyy', {
        locale: ptBR
      });
    }

    return '';
  };

  return (
    <Container>
      {scheduleUnits.map((location, index) => (
        <UnitCard
          key={location.id + index}
          onLocationSelected={() => onLocationSelected(location)}
          location={location}
          isChecked={selectedUnit?.id === location.id}
          closestDateAvailable={getclosestDateAvailable(getUnitIdAndLocalId(location))}
          isOpenToSchedule
          showRadio={!!scheduleUnits.length}
        />
      ))}
    </Container>
  );
};
